// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2Ia8h","log":"ModalInventoryLogs_log__r6hgB","date":"ModalInventoryLogs_date__1uiIo","userName":"ModalInventoryLogs_userName__3hX83"};